import { QueryClient } from "@tanstack/react-query";
import { QUERY_CLIENT_CONFIG } from "./query-client-config";
export var queryClient = new QueryClient(QUERY_CLIENT_CONFIG);
